<template>
  <v-select
    :items="[
      'Regular',
      'Irregular',
      'Placetado',
      'Eterno',
    ]"
    v-on="$listeners"
    v-bind="$attrs"
  />
</template>

<script lang="ts">
export default {
	inheritAttrs: false,
}
</script>
